import App from './components/app';
import { getClientBundleHelpers } from '../bundle-maker';

const { initBundle } = getClientBundleHelpers(App);
const { state, data, hotRender } = window.wirthBootstrap;

initBundle(state, data, hotRender);

export default initBundle;
